/*
 * @Date: 2022-08-29 11:18:04
 * @LastEditors: kinfai
 * @Description:
 * @LastEditTime: 2022-08-31 11:59:59
 * @FilePath: \my-app\src\pages\ChatConversation\components\ContentEditor\index.jsx
 */
import './index.less'
import { useState, useEffect, useRef } from "react";
import { useClickAway } from 'ahooks';
import { Input, Popover } from "antd";
import AliIcon from "@/components/AliIcon";
import UploadImg from "@/components/UploadImg";
import { SmileOutlined } from '@ant-design/icons';
import Picker from 'emoji-picker-react';
import {getPluginConfig} from "@/hooks/chatPlugin/index.js";



function ContentEditor(props) {
    const { addMsg } = props

    const [content, updateContent] = useState("")
    const { TextArea } = Input

    const SIZE = "20px"

    const sendMsg = () => {
        // console.log("发送消息", content)
        // addMsg({
        //     value: content,
        //     id: content.data,
        //     isMe: true,
        //     isRead: false,
        //     type: "text"
        // })
        addMsg(content)
        if (String(content).trim() !== '') {
            updateContent("")
        }
    }
    const enterSend = e => {
        if (e.key === 'Enter' && !e.ctrlKey) {
            sendMsg()
            setTimeout(() =>{
                updateContent("")
            })
        }
        if (e.key === 'Enter' && e.ctrlKey) {
            const value = content + "\n"
            updateContent(value)
        }
    }

    // 判断用户是否输入
    const changeUserStatus = (type) => {
        // todo
        console.log("当前", type)
    }

    // useEffect(() => {
    //     console.log("useEffect", content)
    // }, [content])


    // 点击外部
    const emojiRef = useRef(null);
    const smileRef = useRef(null)
    useClickAway(() => {
        if (emojiVisible) setEmojiVisible(false);
    }, [emojiRef, smileRef]);

    // 表情
    const [emojiVisible, setEmojiVisible] = useState(false);
    const onEmojiClick = (event, emojiObject) => {
        const addMsg = content + emojiObject.emoji
        setEmojiVisible(false)
        updateContent(addMsg)
    };
    const emojiSelect = () => {
        return (
            <div
                ref={emojiRef}
            >
                <Picker
                    pickerStyle={{
                        display: emojiVisible === true ? '' : 'none'
                    }}
                    onEmojiClick={onEmojiClick}
                    disableSkinTonePicker={true}
                />
            </div>)
    }

    const {btnColor} = getPluginConfig()

    return <div
        className="g-msg-bottom-area"
        style={{
            height: "120px",
            borderRadius: '0px 0px 8px 8px',
            backgroundColor: "rgba(255, 255, 255, 100)",
            border: "1px solid rgba(236, 236, 236, 100)"
        }}>
        <TextArea
            style={{ flex: 1 }}
            bordered={false}
            placeholder="Input..."
            value={content}
            onChange={e => updateContent(e.target.value)}
            onFocus={() => changeUserStatus('typing')}
            onBlur={() => changeUserStatus('')}
            onKeyDown={enterSend}
        />
        <div className="g-msg-bottom-menu">
            <div className="g-left-btn-menu">
                <Popover content={emojiSelect} visible={emojiVisible}>
                    <SmileOutlined
                        ref={smileRef}
                        onClick={() => setEmojiVisible(true)}
                        style={{
                            color: "#A4ADB3",
                            fontSize: SIZE,
                            marginRight: "6px",
                        }} />
                </Popover>
                {/*<UploadImg Content={() => <AliIcon type="icon-tuku" size={SIZE} color="#A4ADB3"></AliIcon>}></UploadImg>*/}
            </div>
            <div className="g-right-btn-menu">
                <AliIcon
                    onClick={sendMsg}
                    type="icon-fasong" size={SIZE} color={btnColor || "#4654A3"} />
            </div>
        </div>
    </div>
}

export default ContentEditor
